// extracted by mini-css-extract-plugin
module.exports = {"item":"answers_item__GGf21","question":"answers_question__URD_R","answer":"answers_answer__7M4Pw"};